import { Route, Routes } from 'react-router-dom'
import AppLayout from '../../layouts/web/AppLayout'
import Auth from '../../middleware/Auth'
import Home from '../../pages/web/Home'
import CoursesAndOffers from '../../pages/web/CoursesAndOffers'
import Lectures from '../../pages/web/Lectures'
import AllOffers from '../../pages/web/AllOffers'
import OfferContent from '../../pages/web/OfferContent'
import Lecture from '../../pages/web/Lecture'
import StarterPage from '../../features/web/lecture/components/StarterPage'
import Player from '../../features/web/lecture/components/Player'
import QuizResult from '../../features/web/quiz/components/QuizResult'
import QuizAnswers from '../../features/web/quiz/components/QuizAnswers'
import RedeemedLectures from '../../pages/web/RedeemedLectures'
import ProfileLayout from '../../layouts/profile/ProfileLayout'
import UserInfo from '../../pages/web/UserInfo'
import UserStats from '../../pages/web/UserStats'
import UserLectures from '../../pages/web/UserLectures'
import UserQuizResults from '../../pages/web/UserQuizResults'
import ErrorPage from '../../components/errorPage/ErrorPage'
import Quiz from '../../pages/web/Quiz'

const WebRoutes = () => {
    return (
        <Routes>
            {/* Web pages not required Auth  */}
            <Route element={<AppLayout />}>
                <Route path="/" element={<Home />} />
                <Route path="/:school_level/:grade/courses" element={<CoursesAndOffers />} />
                <Route path="/:grade/courses/:courseid" element={<Lectures />} />
                <Route path="/:school_level/:grade/offers" element={<AllOffers />} />
                <Route path="/:school_level/:grade/offers/:offerId" element={<OfferContent />} />
            </Route>

            {/* Web pages required Auth  */}
            <Route element={<Auth><AppLayout /></Auth>}>
                <Route path="/:grade/courses/:courseId/lectures/:lectureId/quiz/:quizId/:attemptId" element={<Quiz />} />
                <Route path="/:grade/courses/:courseId/lectures/:lectureId/quiz/:quizId/:attemptId/results" element={<QuizResult />} />
                <Route path="/:grade/courses/:courseId/lectures/:lectureId/quiz/:quizId/:attemptId/answers" element={<QuizAnswers />} />
                <Route path="/redeem" element={<RedeemedLectures />} />
                <Route path="/redeem/:lecture_id" element={<RedeemedLectures />} />
                
                <Route element={<Lecture />}>
                    <Route path="/:grade/courses/:courseId/lectures/:lectureId" element={<StarterPage />} />
                    <Route path="/:grade/courses/:courseId/lectures/:lectureId/video/:videoId" element={<Player />} />
                </Route>

                {/* Profile Layout */}
                <Route element={<ProfileLayout />}>
                    <Route path="/user/profile" element={<UserInfo />} />
                    <Route path="/user/stats" element={<UserStats />} />
                    <Route path="/user/lectures" element={<UserLectures />} />
                    <Route path="/user/quizzesResults" element={<UserQuizResults />} />
                </Route>
            </Route>

            <Route path="*" element={<ErrorPage status={404} error={"هذه الصفحة غير موجودة"} />} />

        </Routes>
    )
}

export default WebRoutes